var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tiptap-vuetify',{attrs:{"card-props":_vm.cardOptions,"placeholder":_vm.placeholder,"extensions":_vm.extensions},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}})}
var staticRenderFns = []

export { render, staticRenderFns }